module.exports = __webpack_public_path__ + "img/company0.e794bba4.png";